import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/reports",
    component: LayoutPage,
    children: [
      {
        path: "",
        name: "reports-page",
        component: () => import("@/views/Reports/ReportsPage.vue"),
        meta: {
          title: "Reports",
          titleLocalizationCode: "Reports",
          desc: "Reports page",
          descLocalizationCode: "Reports_Page",
          sidebarElement: false,
          permissionCodes: [
            // "CostCenter.Read",
          ],
        },
      },
    ],
  },
];
